<div class="content-wrapper container-xxl p-0">
    <div class="content-body">

        <div class="card">
            <div class="card-header">
                <h4 class="card-title">Payment Details</h4>
            </div>

            <div class="card-body">



                <div *ngIf="payment" class="payment-details-card">
                    <div class=" border-0 shadow-sm">
                        <div class="card-body p-3">
                            <!-- Header with Icon and Title -->
                            <div class="d-flex align-items-center">
                                <div class="mr-1">
                                    <i class="bi bi-bank2 text-success" style="font-size: 1.75rem;"></i>
                                </div>
                                <h5 class="mb-0">Bank Account Details</h5>
                            </div>

                            <!-- Divider -->
                            <hr class="my-2">

                            <!-- Details Grid -->
                            <div class="row g-3">
                                <!-- Full Name -->
                                <div class="col-md-12 mb-2">
                                    <div class="detail-item">
                                        <small class="text-muted d-block">Type</small>
                                        <div class="fw-semibold text-truncate badge badge-light-danger">{{ payment.type
                                            || '-' | uppercase }}</div>
                                    </div>
                                </div>

                                <div class="col-md-6">
                                    <div class="detail-item">
                                        <small class="text-muted d-block">Full Name</small>
                                        <div class="fw-semibold text-truncate">{{ payment.fullName || '-' }}</div>
                                    </div>
                                </div>

                                <!-- Bank Name -->
                                <div class="col-md-6 mb-2">
                                    <div class="detail-item">
                                        <small class="text-muted d-block">Bank Name</small>
                                        <div class="fw-semibold text-truncate badge badge-light-primary">{{
                                            payment.bankName || '-' }}</div>
                                    </div>
                                </div>

                                <!-- IBAN -->
                                <div class="col-md-6 mb-2">
                                    <div class="detail-item">
                                        <small class="text-muted d-block">Bank Account Number / IBAN</small>
                                        <div class="fw-semibold font-monospace">{{ payment.iban || '-' }}</div>
                                    </div>
                                </div>

                                <!-- Swift Code -->
                                <div class="col-md-6 mb-2">
                                    <div class="detail-item">
                                        <small class="text-muted d-block">SWIFT/BIC Code</small>
                                        <div class="fw-semibold font-monospace">{{ payment.swift || '-' }}</div>
                                    </div>
                                </div>

                                <!-- Country -->
                                <div class="col-md-6 mb-2">
                                    <div class="detail-item">
                                        <small class="text-muted d-block">Country</small>
                                        <div class="fw-semibold d-flex align-items-center">
                                            <span class="fi fi-{{payment.countryCode?.toLowerCase()}} me-2"></span>
                                            {{ payment.country || '-' }}
                                        </div>
                                    </div>
                                </div>

                                <!-- Email -->
                                <div class="col-md-6 mb-2">
                                    <div class="detail-item">
                                        <small class="text-muted d-block">Email</small>
                                        <div class="fw-semibold text-truncate">
                                            <a *ngIf="payment.email">{{ payment.email }}</a>
                                            <span *ngIf="!payment.email">-</span>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-md-6 mb-2" *ngIf="payment.eWalletType">
                                    <div class="detail-item">
                                        <small class="text-muted d-block">Ewallet Type</small>
                                        <div class="fw-semibold font-monospace">{{ payment.eWalletType || '-' }}</div>
                                    </div>
                                </div>


                                <div class="col-md-6 mb-2" *ngIf="payment.accountType">
                                    <div class="detail-item">
                                        <small class="text-muted d-block">Account Type</small>
                                        <div class="fw-semibold font-monospace">{{ payment.accountType || '-' }}</div>
                                    </div>
                                </div>

                                <div class="col-md-6 mb-2" *ngIf="payment.phoneNumber">
                                    <div class="detail-item">
                                        <small class="text-muted d-block">Phone Number</small>
                                        <div class="fw-semibold font-monospace">{{ payment.phoneNumber || '-' }}</div>
                                    </div>
                                </div>

                            </div>

                            <!-- Verification Status -->
                            <div *ngIf="payment.accountType" class="mt-4 pt-3 border-top text-center">
                                <span class="badge bg-success rounded-pill px-3 py-2">
                                    <i class="bi bi-check-circle-fill me-2"></i>Verified Account
                                </span>
                            </div>
                        </div>
                    </div>
                </div>

                <div *ngIf="!payment" class="no-payment-details text-center py-5">
                    <div class="card border-0 shadow-sm">
                        <div class="card-body p-5">
                            <i class="bi bi-credit-card-2-front text-muted" style="font-size: 3rem;"></i>
                            <h5 class="mt-3 mb-2">No Payment Details Found</h5>
                            <p class="text-muted">This user hasn't provided any bank account information yet.</p>
                            <a [routerLink]="['/accounting/payment-account', this.id]" 
                                class="btn btnn"><i class="bi bi-person-fill-add mr-50"></i>
                                Create Payment Account</a>
                        </div>
                    </div>
                </div>

            </div>



        </div>
    </div>